module.exports = __webpack_public_path__ + "static/media/mortarboard.ddc7e241.svg";